import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Button, Alert, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

function PostManagementPage() {
    const { token } = useAuth();
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [filters, setFilters] = useState({ status: '', type: '' });

    const fetchItems = async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams(filters);
            const { data } = await axios.get(`/api/admin/items?${params.toString()}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setItems(data);
        } catch (err) {
            setError('Failed to fetch items.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchItems();
    }, [token, filters]);

    const handleDeleteItem = async (itemId) => {
        if (window.confirm("Are you sure you want to delete this item permanently?")) {
            try {
                await axios.delete(`/api/admin/items/${itemId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                fetchItems();
            } catch (err) {
                setError('Failed to delete item.');
            }
        }
    };

    return (
        <AdminLayout>
            <Typography variant="h4" gutterBottom>Post Management</Typography>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel>Type</InputLabel>
                    <Select value={filters.type} label="Type" onChange={(e) => setFilters({...filters, type: e.target.value})}>
                        <MenuItem value=""><em>All</em></MenuItem>
                        <MenuItem value="lost">Lost</MenuItem>
                        <MenuItem value="found">Found</MenuItem>
                    </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 120 }}>
                    <InputLabel>Status</InputLabel>
                    <Select value={filters.status} label="Status" onChange={(e) => setFilters({...filters, status: e.target.value})}>
                        <MenuItem value=""><em>All</em></MenuItem>
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="resolved">Resolved</MenuItem>
                    </Select>
                </FormControl>
            </Box>
            {error && <Alert severity="error">{error}</Alert>}
            {loading ? <CircularProgress /> : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Item Name</TableCell>
                                <TableCell>Type</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.map((item) => (
                                <TableRow key={item._id}>
                                    <TableCell>{item.itemName}</TableCell>
                                    <TableCell>{item.type}</TableCell>
                                    <TableCell>{item.status}</TableCell>
                                    <TableCell>
                                        <Button size="small" onClick={() => navigate(`/admin/posts/edit/${item._id}`)}>Edit</Button>
                                        <Button size="small" color="error" onClick={() => handleDeleteItem(item._id)}>Delete</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </AdminLayout>
    );
}

export default PostManagementPage;
